var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gestisci-lavorazioni"},[(_vm.tab === 'tab-1')?_c('Tutti'):_vm._e(),(_vm.tab === 'tab-3')?_c('Associati',{attrs:{"action":'lista',"days":7}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }